import mitt, { Emitter } from 'mitt';

// 定义事件类型
export type EventType = 'explainSnippet' | 'errorExplain' | 'sampleCode' | 'aiAnswer' | 'showAiAssistant' | 'syntaxError' | 'setLoading' | 'showNotification' | 'languageChanged';

// 定义事件数据类型
export interface EventData {
  explainSnippet: { selection: string; fullCode: string; language?: string };
  errorExplain: { error: string; line: number; code?: string };
  sampleCode: { topic: string; language: string };
  aiAnswer: { role: 'assistant' | 'user'; content: string };
  showAiAssistant: Record<string, never>; // 空对象，只用于触发事件
  syntaxError: { selection: string; fullCode: string; compilerMessage: string; language?: string };
  setLoading: { isLoading: boolean }; // 设置加载状态
  showNotification: { type: 'success' | 'error' | 'info' | 'warning'; message: string }; // 显示通知
  languageChanged: { language: string; code?: string; fileName?: string }; // 编程语言变化事件
}

// 创建事件总线实例
const eventBus: Emitter<{
  [K in EventType]: EventData[K];
}> = mitt();

// 导出事件总线
export default eventBus;

// 使用示例
/*
// 发送事件
eventBus.emit('explainSnippet', { code: 'console.log("Hello World");', language: 'javascript' });

// 监听事件
eventBus.on('explainSnippet', ({ code, language }) => {
  console.log(`解释代码: ${code}, 语言: ${language}`);
});

// 移除监听
const handler = ({ error, line }: EventData['errorExplain']) => {
  console.log(`解释错误: ${error}, 行: ${line}`);
};
eventBus.on('errorExplain', handler);
eventBus.off('errorExplain', handler);
*/
